<label class="card-selectable mb-0">
  <div class="row gx-2">
    <div class="col">
      @if (inputElem().content?.title) {
        <p class="text-secondary mb-2"><b [translate]="inputElem().content.title"></b></p>
      }
      <div class="row gx-3">
        @for (category of inputElem().content?.categories; track category) {
          <div class="col-auto text-center">
            <mwe-product-icon [category]="category" size="md" textNodeType="p" />
          </div>
        }
        @if (inputElem().content?.categories?.[0]) {
          <p class="text--legal mb-0 mt-2">
            {{ inputElem().content?.categories?.[0] | correlatedCompanyReference }}
          </p>
        }
      </div>
      @if (inputElem().content?.after) {
        <div [translate]="inputElem().content?.after"></div>
      }
    </div>
    <div class="col-auto">
      <input
        [attr.data-test]="'form-input-' + inputElem().name"
        [attr.id]="inputElem().name"
        [name]="inputElem().name"
        [formControl]="control()"
        [ngClass]="{
          'is-invalid': control().errors && !control().pristine,
          'form-check-readonly': isLoading() || inputElem().isReadonly,
        }"
        class="form-check-input"
        type="checkbox"
        [attr.aria-describedby]="ariaDescribedBy"
        [attr.aria-invalid]="!isValid"
        [required]="isRequired || null"
        [attr.disabled]="inputElem().isDisabled ? '' : null"
        mweClickPreventDefault
        [ignorePreventClickDefault]="!inputElem().isReadonly"
        [attr.tabindex]="inputElem().isReadonly ? '-1' : null"
      />
    </div>
  </div>
</label>
